module.exports = __webpack_public_path__ + "static/media/404-not-found-question.37d79771.svg";